import helpers from "@/mixins/helpers"

let validation = function (el, binding, vnode) {
    if (vnode.data.model.value) {
        const valid = helpers.methods.validateCpf(vnode.data.model.value)
        if (!valid) {
            el.classList.remove('success')
            el.classList.add('error')
        } else {
            el.classList.add('success')
            el.classList.remove('error')
        }
    }
}

export default {
    update: function (el, binding, vnode) {
        el.children[1].addEventListener('blur', () => {
            validation(el, binding, vnode)
        })
        validation(el, binding, vnode)
    }
}
